import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Signup from './Signup';
import { signup, signupConfirm } from '../actions';
import * as selectors from '../selectors';

export class SignupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = { isConfirming: false };
  }

  async componentDidMount() {
    const { params } = this.props.match;
    if (
      typeof params.userId !== 'undefined' &&
      typeof params.code !== 'undefined'
    ) {
      this.setState({ isConfirming: true });
      await this.props.signupConfirm(
        params.userId,
        params.code,
        this.props.history
      );
    }
  }

  handleSubmit = values => this.props.signup(values);

  render() {
    const { ui } = this.props;
    return (
      !this.state.isConfirming && (
        <Signup
          onSubmit={this.handleSubmit}
          isLoading={ui.get('isLoading')}
          isError={ui.get('isError')}
          errorMessage={ui.get('errorMessage')}
        />
      )
    );
  }
}

const mapStateToProps = createStructuredSelector({
  ui: selectors.getUI
});

export default connect(mapStateToProps, { signup, signupConfirm })(
  SignupContainer
);



// WEBPACK FOOTER //
// ./src/modules/auth/components/SignupContainer.js